import { forwardRef, type Ref, type SVGProps } from "react";
const IconListNumberedOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7.226 10V4H6.034l-1.486.94v1.125l1.374-.86h.036V10z" />
    <path d="M27.105 8h-15.21C11.358 8 11 7.6 11 7s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1" />
    <path d="M27.105 17h-15.21c-.537 0-.895-.4-.895-1s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1" />
    <path d="M11.895 26h15.21c.448 0 .895-.4.895-1s-.358-1-.895-1h-15.21c-.537 0-.895.4-.895 1s.358 1 .895 1" />
    <path d="M4.179 19v-.902l2.106-1.95q.27-.26.451-.469.186-.208.28-.407a1 1 0 0 0 .096-.437.8.8 0 0 0-.118-.448.8.8 0 0 0-.324-.292 1 1 0 0 0-.465-.104 1 1 0 0 0-.474.11.76.76 0 0 0-.313.315q-.11.206-.11.489H4.122q0-.582.263-1.009a1.75 1.75 0 0 1 .737-.662Q5.596 13 6.214 13q.636 0 1.107.225.474.223.737.619t.263.907q0 .336-.133.662-.13.327-.465.726-.336.395-.945.95l-.864.847v.04h2.485V19z" />
    <path d="M5.078 27.78q.5.22 1.138.22.656 0 1.163-.222.508-.223.796-.61.291-.39.288-.888.003-.544-.337-.906-.335-.366-.98-.448v-.046q.49-.088.795-.416a1.14 1.14 0 0 0 .305-.819 1.42 1.42 0 0 0-.25-.832 1.74 1.74 0 0 0-.705-.593A2.4 2.4 0 0 0 6.233 22q-.6 0-1.075.22a1.87 1.87 0 0 0-.753.601 1.52 1.52 0 0 0-.288.89H5.3a.67.67 0 0 1 .134-.388.8.8 0 0 1 .334-.254q.208-.09.46-.09.248 0 .433.093a.7.7 0 0 1 .396.648q0 .231-.12.405a.8.8 0 0 1-.336.268 1.2 1.2 0 0 1-.494.096h-.544v.907h.544q.331 0 .57.103a.84.84 0 0 1 .371.285q.132.18.132.414 0 .231-.123.407a.8.8 0 0 1-.34.277q-.216.1-.498.1-.272 0-.488-.088a.86.86 0 0 1-.348-.249.65.65 0 0 1-.14-.376H4q.009.51.294.901.288.388.784.61" />
  </svg>
);
const ForwardRef = forwardRef(IconListNumberedOutlineSVG);
ForwardRef.displayName = "IconListNumberedOutline";
export { ForwardRef as IconListNumberedOutline };
